import React from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-50 border-t border-slate-200 mt-12">
      <div className="max-w-7xl mx-auto px-4 py-6">
        {/* Disclaimer */}
        <div className="flex items-start gap-2 mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
          <AlertCircle className="h-4 w-4 text-amber-600 flex-shrink-0 mt-0.5" />
          <p className="text-xs text-amber-900">
            <strong>Personal health tracking only.</strong> No medical advice or clinical decision-making.
          </p>
        </div>

        {/* Links */}
        <div className="flex flex-wrap justify-center gap-4 mb-3">
          <Link 
            to="/blog" 
            className="text-xs text-slate-600 hover:text-primary transition-colors"
          >
            Blog
          </Link>
          <span className="text-xs text-slate-400">•</span>
          <Link 
            to="/terms" 
            className="text-xs text-slate-600 hover:text-primary transition-colors"
          >
            Terms of Service
          </Link>
          <span className="text-xs text-slate-400">•</span>
          <Link 
            to="/privacy" 
            className="text-xs text-slate-600 hover:text-primary transition-colors"
          >
            Privacy Policy
          </Link>
          <span className="text-xs text-slate-400">•</span>
          <Link 
            to="/glossary" 
            className="text-xs text-slate-600 hover:text-primary transition-colors"
          >
            Glossary
          </Link>
        </div>

        {/* Copyright */}
        <p className="text-center text-xs text-slate-500">
          © {new Date().getFullYear()} Blood Cancer Companion. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
